import { Box, Grid, lighten, List, ListItem, ListItemText, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Colors } from 'src/shared/components/styles/colors';
import numberWithSpaces from 'src/shared/functions/numberWithSpaces';
import { MemberStats } from '../../models/memberStats';
import { HeaderSubTitle } from '../atoms/headerSubTitle';
import { ContactChartSkeleton } from './contactChartSkeleton';

export const chartColors = [lighten(Colors.ChipColors.Blue, 0.5), Colors.ColorBox.LightBlue, lighten(Colors.ChipColors.Red, 0.4)];

type ContactsChartProps = {
  memberStats: MemberStats | undefined;
  isLoading: boolean;
};

export const ContactsChart = (props: ContactsChartProps) => {
  const { memberStats, isLoading } = props;
  const { t } = useTranslation();

  const theme = useTheme();

  const isXS = useMediaQuery(theme.breakpoints.down('sm'));
  // const isMD = useMediaQuery(theme.breakpoints.down('lg'));

  const labelData = [
    [t('dashboard:members.contactWays.header'), t('dashboard:members.contactWays.count'), { role: 'style' }],
    [t('dashboard:members.contactWays.email'), memberStats?.nrOfEmail, Colors.ChipColors.Blue],
    [t('dashboard:members.contactWays.mobileNr'), memberStats?.nrOfPhone, Colors.ChipColors.Green],
    [t('dashboard:members.contactWays.missing'), memberStats?.nrOfNoEmailOrPhone, Colors.ChipColors.Red],
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <HeaderSubTitle label={t('dashboard:members.contactWays.header')} />
        {isLoading && (
          <>
            <ContactChartSkeleton />
            <ContactChartSkeleton />
            <ContactChartSkeleton />
          </>
        )}
        {!isLoading && memberStats && (
          <List dense disablePadding>
            {labelData.slice(1).map((x, ix) => {
              const childs = x.toString().split(',');
              const widthOfBar = `${((childs[1] as unknown as number) / memberStats.nrOfMembers) * 100}%`;
              return (
                <ListItem
                  key={childs[0]}
                  disablePadding
                  alignItems='flex-start'
                  sx={{ display: 'flex', flexDirection: isXS ? 'column' : 'row', alignItems: 'start' }}
                >
                  {/* <ListItemButton disableGutters sx={{ width: '30%' }}> */}
                  <ListItemText sx={{ '& *': { lineHeight: '1.2 !important' }, mb: 1, width: '30%' }}>
                    <Typography sx={{ fontWeight: 600, fontSize: '1.5rem' }}>{numberWithSpaces((childs[1] as unknown as number) || 0)}</Typography>
                    <Typography variant={isXS ? 'caption' : 'overline'}>{childs[0]}</Typography>
                  </ListItemText>
                  {/* </ListItemButton> */}
                  <ListItemText sx={{ width: '65%', mt: isXS ? 0 : 2 }}>
                    <Box sx={{ width: '100%', height: '10px', backgroundColor: Colors.Form.DisabledInput, borderRadius: 1 }}>
                      <Box
                        sx={{
                          width: widthOfBar,
                          height: '10px',
                          backgroundColor: chartColors[ix],
                          borderRadius: 1,
                        }}
                      />
                    </Box>
                  </ListItemText>
                </ListItem>
              );
            })}
          </List>
        )}
      </Grid>
    </Grid>
  );
};
